import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import { InfoCardItem } from './info-card.reducer';

export const infoCardActions = {
  insert: createAction('load/info-card-1/load'),
  insertDone: createAction('load/info-card-1/done', props<{ state: ILoaderActionPayload; data?: number }>()),
  inProgress: createAction('load/info-card-2/load'),
  inProgressDone: createAction('load/info-card-2/done', props<{ state: ILoaderActionPayload; data?: number }>()),
  processed: createAction('load/info-card-3/load'),
  processedDone: createAction('load/info-card-3/done', props<{ state: ILoaderActionPayload; data?: number }>()),
  rejected: createAction('load/info-card-4/load'),
  rejectedDone: createAction('load/info-card-4/done', props<{ state: ILoaderActionPayload; data?: number }>()),
};
